import { connect } from "react-redux";
import LoginPage from "./LoginPage";
import { initLoginComp, validResetLink } from "./../actions/LoginActions";

const mapStateToProps = state => {
  const { loginData } = state.login;

  return {
    loginData
  };
};

const mapDispatchToProps = dispatch => {
  return {
    initLoginComp: appHashPath => {
      dispatch(initLoginComp(appHashPath));
    },
    validResetLink: callbackFn => {
      validResetLink(callbackFn);
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
